import { r4Client, r4Error } from "@/services";

const StatsApi = {
  /**
   *
   * @param {account_key} string - account key
   * @param {ndays} string - number of days in the past
   * @param {sender_key} string - sender key: optional: If no sender_key, it will return stats for all sender
   * @param {campaign_id} string - campaign_id: optional: If no campaign_id, it will return stats for all campaigns
   * @returns
   */
  async fetchDailyStats ({ account_key = null, sender_key = null, campaign_id = null, ndays = null }) {
    const queryParams = {}
    if (account_key) queryParams.account_key = account_key;
    if (sender_key) queryParams.sender_key = sender_key;
    if (campaign_id) queryParams.campaign_id = campaign_id;
    if (ndays) queryParams.ndays = ndays;

    try {
      let resp;
      if (queryParams.sender_key) {
        resp = await r4Client().get('/api/v2/email_campaign_stats/daily_stats', { params: queryParams });
      } else {
        resp = await r4Client().get('/api/v2/email_campaign_stats/sender_stats_by_day_and_date_range', { params: queryParams });
      }
      return resp.data.data;
    } catch (error) {
      throw r4Error(error);
    }
  },


  // CampaignActivityStats component - sender_stats_by_date_range
  async fetchCampaignStatsBySender ({ senderId, daysInPast, campaignId }) {
    const queryParams = {
      sender_key: senderId,
      ndays: daysInPast
    }

    if (campaignId) {
      queryParams.campaign_id = campaignId
    }

    try {
      const resp = await r4Client().get('/api/v2/email_campaign_stats/campaign_stats_by_date_range', { params: queryParams });
      return resp.data.data;
    } catch (error) {
      throw r4Error(error);
    }

  },

  // ActivityByDealer - for account view of dealer send counts for period
  async dealerStatsByPeriod (params) {
    const queryParams = {
      account_key: params.account_key,
      ndays: params.past_n_days
    }
    try {
      const resp = await r4Client().get('/api/v2/email_campaign_stats/sender_stats_by_date_range', { params: queryParams });
      return resp.data.data;
    } catch (error) {
      throw r4Error(error);
    }
  },

  // for account view - daily dealer stats
  async fetchDailyStatsForAccountSenders (queryParams) {
    try {
      const resp = await r4Client().get('/api/v2/email_campaign_stats/sender_stats_by_day_and_date_range', { params: queryParams });
      return resp.data.data;
    } catch (error) {
      throw r4Error(error);
    }
  },
}

export default StatsApi